import React from "react";
import "./productCard.css";
import Img4 from "./hand.png";
const ProductCard = (props) => {
  return (
    <>
      <div className="productCard">
        <div className="productCardheading ">{props.Heading}</div>
        <div style={{ position: "relative", "background-color": "#F2F2F2" ,"height": "19rem"}}>
          <img className="productCardImg " src={Img4} alt="Img" />
          <p style={{ padding: "4rem 1rem 0rem 1rem", "text-align": "center" }}>
            {props.Text}
          </p>
        </div>
      </div>
    </>
  );
};

export default ProductCard;
